import { useState, useEffect } from 'react';
import Page from '../components/Page';
import image from '../static/images/Jobs.webp';
import cafeChef from '../static/pdf/Job_Cafe_Chef_De_Partie.pdf';
import clubBar from '../static/pdf/Job_Club_Bar_Staff.pdf';
import clubRunner from '../static/pdf/Job_Club_Runner.pdf';
import wardrobeHost from '../static/pdf/wardrobe.pdf';
import jrComm from '../static/pdf/Job_Jr_Communications_Manager.pdf';


const Jobs = (props) => {

  const [innerContent, setInnerContent] = useState('');
  const [innerContentEN, setInnerContentEN] = useState('');




  useEffect(() => {
    fetch('./content/jobs-NL.html').then((response) => {
    return response.text();
    }).then((html) => {
    setInnerContent(html);
  });

    fetch('./content/jobs-EN.html').then((response) => {
    return response.text();
    }).then((html) => {
    setInnerContentEN(html);
  });
    },[]);

  const content = <div className="content"
    dangerouslySetInnerHTML={{__html: innerContent ? innerContent : ''}}></div>

  const contentEN = <div className="content"
  dangerouslySetInnerHTML={{__html: innerContentEN ? innerContentEN : ''}}></div>

  document.title = 'Jobs - De School Amsterdam';
  const headerTitle = 'Jobs DS';
  const description = 'Jobs Jobs Jobs Jobs Jobs Jobs Jobs Jobs Jobs Jobs Jobs Jobs';


  return <Page
          headerTitle={headerTitle}
          description={description}
          content={props.langNL ? content : contentEN}
          image={image}
          langNL={props.langNL}
          changeLang={props.changeLang}/>


};

export default Jobs;
